export default __webpack_public_path__ + "static/media/email-campaign-cuate.2cce80f9.svg";